import { BaseRestAPIService } from "@/services/base-rest-api.service";

export class PublicService extends BaseRestAPIService {
  constructor() {
    super(`public`);
  }

  async storeSignUp(body: {
    email: string;
    phone: string;
  }): Promise<{ stashId: string; expiresAt: number } | void> {
    try {
      const response = await fetch(`${this.apiUrl}/store-signup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(await this.getHttpRequestOptions()),
        },
        body: JSON.stringify(body),
      });

      if (response.status === 204 || response.status === 205) return;

      const contentType = response.headers.get("content-type") || "";
      if (contentType.includes("application/json")) {
        return (await response.json()) as {
          stashId: string;
          expiresAt: number;
        };
      }

      return;
    } catch (e) {
      console.log("Failed to store data", e);
    }
  }

  async retrieveSignUp(
    stashId: string
  ): Promise<{ email?: string; phone?: string } | null> {
    const response = await fetch(`${this.apiUrl}/retrieve-signup/${stashId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...(await this.getHttpRequestOptions()),
      },
    });

    const contentType = response.headers.get("content-type") || "";
    if (!contentType.includes("application/json")) return null;
    return (await response.json()) as { email?: string; phone?: string } | null;
  }

  async retrieveSignUpByPhone(
    phone: string
  ): Promise<{ email?: string; phone?: string } | null> {
    const response = await fetch(
      `${this.apiUrl}/retrieve-signup/by-phone/${encodeURIComponent(phone)}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...(await this.getHttpRequestOptions()),
        },
      }
    );

    const contentType = response.headers.get("content-type") || "";
    if (!contentType.includes("application/json")) return null;
    return (await response.json()) as { email?: string; phone?: string } | null;
  }
}
